import type { FC, SVGProps } from "react"
import {
	IconAlignLeftOutline18 as AlignLeft,
	IconCircleArrowUpOutline18 as ArrowUpCircle,
	IconCircleCheckOutline18 as CircleCheck,
	IconTagOutline18 as Tag,
	IconUsersOutline18 as Users,
} from "nucleo-ui-outline-18"

import { LinearIcon } from "@productlane/ui"

export interface RoutineCapability {
	Icon: FC<SVGProps<SVGSVGElement>>
	label: string
	/** The constraint, which is the part that makes the action safe to allow. */
	detail: string
}

export const ROUTINE_CAPABILITIES: RoutineCapability[] = [
	{
		Icon: Tag,
		label: "Tag a thread",
		detail: "Reuses your tags, or creates one",
	},
	{
		Icon: ArrowUpCircle,
		label: "Set importance",
		detail: "Blocking bugs land as Important",
	},
	{
		Icon: Users,
		label: "Assign a teammate",
		detail: "By name, or the least busy teammate",
	},
	{
		Icon: AlignLeft,
		label: "Write a note",
		detail: "Internal summary or translation",
	},
	{
		Icon: LinearIcon,
		label: "File a Linear issue",
		detail: "Engineering work, or links what exists",
	},
	{
		Icon: CircleCheck,
		label: "Close or reopen",
		detail: "Its own thread, never another one",
	},
]

/** Mirrors the tools absent from the routine tool set, so this stays truthful. */
export const ROUTINE_RESTRICTIONS = [
	"replies to a customer",
	"deletes anything",
	"edits a message",
	"touches another thread",
]

export const ROUTINE_LIMITS_SENTENCE = `Never ${ROUTINE_RESTRICTIONS.slice(
	0,
	-1,
).join(", ")}, or ${ROUTINE_RESTRICTIONS.at(-1)}.`
